import { DestroyRef, effect, inject } from '@angular/core';
import { PageHeaderService } from './page-header.service';

type BoolGetter = () => boolean;
type StringGetter = () => string;

export function bindPageHeaderAction(
    enabled: BoolGetter,
    label: string | StringGetter,
    action: () => void
): void {
    const header = inject(PageHeaderService);
    const destroyRef = inject(DestroyRef);

    effect(
        () => {
            if (!enabled()) {
                header.clearAction();
                return;
            }

            const resolvedLabel = typeof label === 'string' ? label : label();
            header.setAction(resolvedLabel, action);
        }
    );

    destroyRef.onDestroy(() => header.clearAction());
}
